// extracted by mini-css-extract-plugin
export default {"carousel":"HomeCarousel_carousel__6GjEl"};